import { render, staticRenderFns } from "./CustomHead.vue?vue&type=template&id=7b5689da&scoped=true"
import script from "./CustomHead.vue?vue&type=script&lang=js"
export * from "./CustomHead.vue?vue&type=script&lang=js"
import style0 from "./CustomHead.vue?vue&type=style&index=0&id=7b5689da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5689da",
  null
  
)

export default component.exports